import { render, staticRenderFns } from "./resultModal.vue?vue&type=template&id=4f712a7a&scoped=true"
import script from "./resultModal.vue?vue&type=script&lang=js"
export * from "./resultModal.vue?vue&type=script&lang=js"
import style0 from "./resultModal.vue?vue&type=style&index=0&id=4f712a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f712a7a",
  null
  
)

export default component.exports